// Flare (@flareapp/js 1.2.1) collects document.cookie into report.context.cookies
// and maps it to the wire attribute "http.request.cookies". Our access/refresh
// tokens live in cookies, so they must never leave the browser (AAR-2041).

const SENSITIVE_KEYS = new Set([
	'cookie',
	'cookies',
	'set-cookie',
	'authorization',
	'proxy-authorization',
	'http.request.cookies',
	'http.request.headers',
])

function scrub(value: unknown, depth: number): void {
	if (depth > 5 || value === null || typeof value !== 'object') return
	for (const key of Object.keys(value as Record<string, unknown>)) {
		if (SENSITIVE_KEYS.has(key.toLowerCase())) {
			delete (value as Record<string, unknown>)[key]
		} else {
			scrub((value as Record<string, unknown>)[key], depth + 1)
		}
	}
}

/** beforeSubmit hook: drops cookies and Authorization/Cookie headers from a Flare report. Never throws. */
export function stripSensitive<T>(report: T): T {
	try {
		scrub((report as { context?: unknown } | null)?.context, 0)
	} catch {
		// fail safe: last resort, drop the whole context rather than leak
		try {
			;(report as { context?: unknown }).context = {}
		} catch {
			// ignore
		}
	}
	return report
}
